  export class MonthlyRecurringFeeModel {
        amount: number;
        currencyCode: string;
   }
